import React from 'react';
export function Section3Question() {
  return <section className="w-full bg-white py-16 px-4 border-b border-gray-200" data-id="element-76">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-77">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 border-b-2 border-gold-500 pb-4 inline-block" data-id="element-78">
          LA PREGUNTA QUE CAMBIÓ TODO
        </h2>

        <div className="space-y-6 text-lg text-gray-800 font-serif leading-relaxed" data-id="element-79">
          <p data-id="element-80">
            Después de documentar miles de casos de fraude, nuestro equipo de
            investigación se dividió.
          </p>

          <p data-id="element-81">
            La mitad quería publicar solo el reporte de estafas y cerrar el
            caso.
          </p>

          <p data-id="element-82">La otra mitad tenía una pregunta que no podía ignorar:</p>

          <div className="bg-gray-50 border-l-4 border-navy-900 p-6 my-8 shadow-sm" data-id="element-83">
            <p className="text-xl md:text-2xl font-bold text-navy-900 italic" data-id="element-84">
              "Si hay tanto fraude... ¿significa que el poder real no existe? ¿O
              significa que el poder real existe — y por eso hay tantos que lo
              imitan?"
            </p>
          </div>

          <p data-id="element-85">Decidimos buscar la respuesta.</p>

          <p data-id="element-86">No en libros. No en internet.</p>

          <p className="font-bold text-navy-900" data-id="element-87">
            En campo. En persona. Cara a cara.
          </p>

          <p data-id="element-88">
            Durante 14 meses adicionales, nuestro equipo viajó por comunidades
            hispanas de Estados Unidos buscando algo que pudiéramos verificar
            con nuestros propios ojos.
          </p>

          <p data-id="element-89">Investigamos más de 60 practicantes espirituales.</p>

          <p data-id="element-90">59 de ellos no pudieron demostrar absolutamente nada.</p>

          <p className="font-bold text-xl text-navy-900 mt-8 border-b border-gray-300 pb-4" data-id="element-91">
            Pero el número 60 fue diferente.
          </p>
        </div>
      </div>
    </section>;
}